import { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;

const HeaderSpacer = styled.div`
  height: ${({ $hasBanner }) => $hasBanner ? '120px' : '80px'};
`;

const MainContainer = styled.div`
  min-height: calc(100vh - ${({ $hasBanner }) => $hasBanner ? '120px' : '80px'});
  background: ${({ theme }) => theme.colors.background};
`;

const LayoutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.md};
`;

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isPremium } = useAuth();
  const [roomName, setRoomName] = useState('');
  const showBanner = user && !isPremium;

  useEffect(() => {
    const fetchRoomName = async () => {
      const paths = location.pathname.split('/').filter(Boolean);
      const roomId = paths[paths.length - 1];
      
      if (paths[0] === 'inventory' || paths[0] === 'bin-setup') {
        try {
          const roomDoc = await getDoc(doc(db, 'rooms', roomId));
          if (roomDoc.exists()) {
            setRoomName(roomDoc.data().name);
          }
        } catch (error) {
          console.error('Error fetching room name:', error);
        }
      }
    };

    fetchRoomName();
  }, [location]);

  return (
    <PageWrapper>
      <HeaderSpacer $hasBanner={showBanner} />
      <MainContainer $hasBanner={showBanner}>
        <LayoutContainer>
          {children}
        </LayoutContainer>
      </MainContainer>
    </PageWrapper>
  );
};

export default Layout; 